import PanelSubMenus        from "../views/template/SubMenus.vue";

import Puestos              from "../views/catalogos/puestos/List.vue";
import Departamento         from "../views/catalogos/departamento/List.vue";
import Tintes               from "../views/catalogos/tinteConfigs/List.vue";
import Materiales           from "../views/catalogos/materiales/List.vue";
import SubLineas            from "../views/catalogos/grupolineas/List.vue";
import Biseles              from "../views/catalogos/biseles/List.vue";
import Armazones            from "../views/catalogos/armazones/List.vue";
import Protecciones         from "../views/catalogos/protecciones/List.vue";
import Recubrimientos       from "../views/catalogos/recubrimientos/List.vue";
import Colores              from "../views/catalogos/colores/List.vue";
import RangosEsferas        from "../views/catalogos/rangosesferas/List.vue";
import RangosCilindros      from "../views/catalogos/rangoscilindros/List.vue";
import RangosAdicionales    from "../views/catalogos/rangosadicionales/List.vue";
import TiposLentes          from "../views/catalogos/tiposlentes/List.vue";
import Paqueterias          from "../views/catalogos/paqueterias/List.vue";
import FechasPaquetes       from "../views/catalogos/fechaspaquetes/List.vue";
import CatasEstatus         from "../views/catalogos/catasestatus/List.vue";
import MzipArticulos        from "../views/catalogos/articulos/List.vue";
import TipoLentexSublinea   from "../views/catalogos/tiposlentes/tiposlentesxsublineas/List.vue";
import ArticulosWeb         from "../views/catalogos/tiposlentes/articulosweb/List.vue";
import ArticulosxMateriales from "../views/catalogos/tiposlentes/articulosxmateriales/Form.vue";
import ArticuloxGraduaciones from "../views/catalogos/tiposlentes/articulosxgraduaciones/Form.vue";

const VarRutasConfiguracion = [
    {
        path: '/paneldetalle',
        name: 'panelSubMenus',
        component: PanelSubMenus,
        props: true
    },
    {
        path: '/tintes',
        name: 'tintes',
        component: Tintes,
        props: false
    },
    {
        path: '/materiales',
        name: 'materiales',
        component: Materiales,
        props: false
    },
    {
        path: '/sublinea',
        name: 'sublineas',
        component: SubLineas,
        props: false
    },
    {
        path: '/biseles',
        name: 'biseles',
        component: Biseles,
        props: false
    },
    {
        path: '/armazones',
        name: 'armazones',
        component: Armazones,
        props: false
    },
    {
        path: '/protecciones',
        name: 'protecciones',
        component: Protecciones,
        props: false
    },
    {
        path: '/recubrimientos',
        name: 'recubrimientos',
        component: Recubrimientos,
        props: false
    },
    {
        path: '/colores',
        name: 'colores',
        component: Colores,
        props: false
    },
    {
        path: '/rangosesferas',
        name: 'rangosesferas',
        component: RangosEsferas,
        props: false
    },
    {
        path: '/rangoscilindros',
        name: 'rangoscilindros',
        component: RangosCilindros,
        props: false
    },
    {
        path: '/rangosadicionales',
        name: 'rangosadicionales',
        component: RangosAdicionales,
        props: false
    },
    {
        path: '/tiposlentes',
        name: 'tiposlentes',
        component: TiposLentes,
        props: false
    },
    {
        path: '/paqueterias',
        name: 'paqueterias',
        component: Paqueterias,
        props: false
    },
    {
        path: '/garantiaentregas',
        name: 'fechaspaquetes',
        component: FechasPaquetes,
        props: false
    },
    {
        path: '/estatuspedidos',
        name: 'catasestatus',
        component: CatasEstatus,
        props: false
    },
    {
        path: '/articulos',
        name: 'articulos',
        component: MzipArticulos,
        props: true
    },
    {
        path: '/tipolentexsublinea',
        name: 'tipolentexsublinea',
        component: TipoLentexSublinea,
        props: true
    },
    {
        path: '/articulosweb',
        name: 'articulosweb',
        component: ArticulosWeb,
        props: true
    },
    {
        path: '/articulosxmateriales',
        name: 'articulosxmateriales',
        component: ArticulosxMateriales,
        props: true
    },
    {
        path: '/articulosxgraduaciones',
        name: 'articulosxgraduaciones',
        component: ArticuloxGraduaciones,
        props: true
    },
    
    
    
    /* ,{
        path: '/Puestos',
        name: 'puestos',
        component: Puestos,
        props: true
    }, */ 
   
    
];

export default {
    VarRutasConfiguracion,
}
